enum Tab {
  MostPopular = 'most_popular',
  Newest = 'newest',
  Feed = 'feed',
  Public = 'public',
}

export default Tab;
